import type { RouteRecordRaw } from 'vue-router'
import router from '@/router'
import { createAccountManageRoute } from '@/views/dashboard/account_manage/AccountManage.vue'
import AccountManage from '@/views/dashboard/account_manage/AccountManage.vue'
import ChangeLabel from '@/views/dashboard/account_manage/ChangeLabel.vue'
import HideAccount from '@/views/dashboard/account_manage/HideAccount.vue'

const accountManageRoutes = [
  {
    name: 'AccountManage',
    component: AccountManage,
  },
  {
    name: 'ChangeLabel',
    component: ChangeLabel,
  },
  {
    name: 'HideAccount',
    component: HideAccount,
  },
]

export const manageAccountRoute = (params: {
  name: string
  path?: string
  onSelectRoute: (name: string) => void
}): RouteRecordRaw => {
  return {
    name: params.name,
    path: params.path ?? 'manage',
    component: createAccountManageRoute({
      onSelectRoute: params.onSelectRoute,
    }),
    props: true,
  }
}
export const accountManageRoute = manageAccountRoute({
  name: 'accountManage',
  onSelectRoute(name: string) {
    router.replace({
      name,
      query: router.currentRoute.value.query,
    })
  },
})

export const accountManageViewRoutes = () => {
  return accountManageRoutes.map((route) => {
    return {
      name: route.name,
      path: `manage/${route.name}`,
      component: () =>
        import(`../../views/dashboard/account_manage/${route.name}.vue`),
      props: true,
    }
  })
}
